// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iZKt","top":"styles_top__3gGmw","left":"styles_left__13CNt","description":"styles_description__3Mt9V"};